import React, { Fragment } from 'react';
import InfoDot from './InfoDot';

export default function WithLabel({ info, label, children, dontUseLabelElement = false }) {
	const content = <Fragment>
		<div className="label">{label}&nbsp;&nbsp;{info && <InfoDot msg={info} />}</div>
		{children}
	</Fragment>;

	if (dontUseLabelElement) return <div className="label-wrapper">{content}</div>;
	return <label>{content}</label>;
}
